import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notifyError, notifySuccess } from "@shared/Toast/toast";
import useAxiosConfig from "@shared/Helpers/axios/useAxiosConfig";
import { useSelector } from 'react-redux';

export default function useCreateStudent() {
 const lang = useSelector((state) => state?.global?.lang);
  const instance = useAxiosConfig();

  function createStudent(data) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        lang: lang,
      },
    };

    return instance.post(`register`, data, config);
  }
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createStudent(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["create student"]);
      notifySuccess(
        lang == "ar" ? "تم انشاء طالب جديد" : "A new student has been created"
      );
    },
    onError: (err) => {
      notifyError(err?.response?.data?.message);
    },
  });
}
